import app from '../store/modules/app';

class LoadingHandler {
  setLoading(bool) {
    this.loading = bool;
    app.state.isLoading = bool;
  }
}

const loadingHandler = new LoadingHandler();

export default loadingHandler;
